// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ApiError,
  CreateIsolationUnit,
  IsolationUnitEntity,
  IsolationUnitList,
  IsolationUnitStatusPatch,
  UpdateIsolationUnitSpec,
} from '../models/index';
import {
  ApiErrorFromJSON,
  ApiErrorToJSON,
  CreateIsolationUnitFromJSON,
  CreateIsolationUnitToJSON,
  IsolationUnitEntityFromJSON,
  IsolationUnitEntityToJSON,
  IsolationUnitListFromJSON,
  IsolationUnitListToJSON,
  IsolationUnitStatusPatchFromJSON,
  IsolationUnitStatusPatchToJSON,
  UpdateIsolationUnitSpecFromJSON,
  UpdateIsolationUnitSpecToJSON,
} from '../models/index';

export interface V1EnvironmentsEnvironmentIsolationUnitsByNameNameGetRequest {
  environment: string;
  name: string;
}

export interface V1EnvironmentsEnvironmentIsolationUnitsGetRequest {
  environment: string;
  cloudProvider?: V1EnvironmentsEnvironmentIsolationUnitsGetCloudProviderEnum;
}

export interface V1EnvironmentsEnvironmentIsolationUnitsPostRequest {
  environment: string;
  createIsolationUnit: CreateIsolationUnit;
}

export interface V1IsolationUnitsIdDeleteRequest {
  id: string;
}

export interface V1IsolationUnitsIdGetRequest {
  id: string;
}

export interface V1IsolationUnitsIdPutRequest {
  id: string;
  updateIsolationUnitSpec: UpdateIsolationUnitSpec;
}

export interface V1IsolationUnitsIdStatusPatchRequest {
  id: string;
  isolationUnitStatusPatch: IsolationUnitStatusPatch;
}

/**
 *
 */
export class IsolationUnitsApi extends runtime.BaseAPI {
  /**
   * Get an isolation unit by operational name
   */
  async v1EnvironmentsEnvironmentIsolationUnitsByNameNameGetRaw(
    requestParameters: V1EnvironmentsEnvironmentIsolationUnitsByNameNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IsolationUnitEntity>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v1EnvironmentsEnvironmentIsolationUnitsByNameNameGet().',
      );
    }

    if (requestParameters['name'] == null) {
      throw new runtime.RequiredError(
        'name',
        'Required parameter "name" was null or undefined when calling v1EnvironmentsEnvironmentIsolationUnitsByNameNameGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments/{environment}/isolation-units/by-name/{name}`;
    urlPath = urlPath.replace(
      `{${'environment'}}`,
      encodeURIComponent(String(requestParameters['environment'])),
    );
    urlPath = urlPath.replace(
      `{${'name'}}`,
      encodeURIComponent(String(requestParameters['name'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IsolationUnitEntityFromJSON(jsonValue),
    );
  }

  /**
   * Get an isolation unit by operational name
   */
  async v1EnvironmentsEnvironmentIsolationUnitsByNameNameGet(
    requestParameters: V1EnvironmentsEnvironmentIsolationUnitsByNameNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IsolationUnitEntity> {
    const response =
      await this.v1EnvironmentsEnvironmentIsolationUnitsByNameNameGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * List isolation units
   */
  async v1EnvironmentsEnvironmentIsolationUnitsGetRaw(
    requestParameters: V1EnvironmentsEnvironmentIsolationUnitsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IsolationUnitList>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v1EnvironmentsEnvironmentIsolationUnitsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['cloudProvider'] != null) {
      queryParameters['cloud_provider'] = requestParameters['cloudProvider'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments/{environment}/isolation-units`;
    urlPath = urlPath.replace(
      `{${'environment'}}`,
      encodeURIComponent(String(requestParameters['environment'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IsolationUnitListFromJSON(jsonValue),
    );
  }

  /**
   * List isolation units
   */
  async v1EnvironmentsEnvironmentIsolationUnitsGet(
    requestParameters: V1EnvironmentsEnvironmentIsolationUnitsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IsolationUnitList> {
    const response = await this.v1EnvironmentsEnvironmentIsolationUnitsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * IMS assigns the id and operational name (ADR-0005).
   * Create an isolation unit
   */
  async v1EnvironmentsEnvironmentIsolationUnitsPostRaw(
    requestParameters: V1EnvironmentsEnvironmentIsolationUnitsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IsolationUnitEntity>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v1EnvironmentsEnvironmentIsolationUnitsPost().',
      );
    }

    if (requestParameters['createIsolationUnit'] == null) {
      throw new runtime.RequiredError(
        'createIsolationUnit',
        'Required parameter "createIsolationUnit" was null or undefined when calling v1EnvironmentsEnvironmentIsolationUnitsPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments/{environment}/isolation-units`;
    urlPath = urlPath.replace(
      `{${'environment'}}`,
      encodeURIComponent(String(requestParameters['environment'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreateIsolationUnitToJSON(
          requestParameters['createIsolationUnit'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IsolationUnitEntityFromJSON(jsonValue),
    );
  }

  /**
   * IMS assigns the id and operational name (ADR-0005).
   * Create an isolation unit
   */
  async v1EnvironmentsEnvironmentIsolationUnitsPost(
    requestParameters: V1EnvironmentsEnvironmentIsolationUnitsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IsolationUnitEntity> {
    const response = await this.v1EnvironmentsEnvironmentIsolationUnitsPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * References from clusters are cleared, not deleted.
   * Delete an isolation unit
   */
  async v1IsolationUnitsIdDeleteRaw(
    requestParameters: V1IsolationUnitsIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1IsolationUnitsIdDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/isolation-units/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * References from clusters are cleared, not deleted.
   * Delete an isolation unit
   */
  async v1IsolationUnitsIdDelete(
    requestParameters: V1IsolationUnitsIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v1IsolationUnitsIdDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Get an isolation unit
   */
  async v1IsolationUnitsIdGetRaw(
    requestParameters: V1IsolationUnitsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IsolationUnitEntity>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1IsolationUnitsIdGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/isolation-units/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IsolationUnitEntityFromJSON(jsonValue),
    );
  }

  /**
   * Get an isolation unit
   */
  async v1IsolationUnitsIdGet(
    requestParameters: V1IsolationUnitsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IsolationUnitEntity> {
    const response = await this.v1IsolationUnitsIdGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * PUT replaces the full spec.
   * Update an isolation unit\'s spec
   */
  async v1IsolationUnitsIdPutRaw(
    requestParameters: V1IsolationUnitsIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IsolationUnitEntity>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1IsolationUnitsIdPut().',
      );
    }

    if (requestParameters['updateIsolationUnitSpec'] == null) {
      throw new runtime.RequiredError(
        'updateIsolationUnitSpec',
        'Required parameter "updateIsolationUnitSpec" was null or undefined when calling v1IsolationUnitsIdPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/isolation-units/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: UpdateIsolationUnitSpecToJSON(
          requestParameters['updateIsolationUnitSpec'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IsolationUnitEntityFromJSON(jsonValue),
    );
  }

  /**
   * PUT replaces the full spec.
   * Update an isolation unit\'s spec
   */
  async v1IsolationUnitsIdPut(
    requestParameters: V1IsolationUnitsIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IsolationUnitEntity> {
    const response = await this.v1IsolationUnitsIdPutRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Observed state only (ADR-0010); reserved for automation. Conditions are upserted by type: each entry replaces the stored entry of its type and every other type is preserved; nothing is removed (ADR-0022). lastTransitionTime is set by the server when status changes. Tenancy ids are set once known and preserved when omitted.
   * Patch an isolation unit\'s status
   */
  async v1IsolationUnitsIdStatusPatchRaw(
    requestParameters: V1IsolationUnitsIdStatusPatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<IsolationUnitEntity>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1IsolationUnitsIdStatusPatch().',
      );
    }

    if (requestParameters['isolationUnitStatusPatch'] == null) {
      throw new runtime.RequiredError(
        'isolationUnitStatusPatch',
        'Required parameter "isolationUnitStatusPatch" was null or undefined when calling v1IsolationUnitsIdStatusPatch().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/isolation-units/{id}/status`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: IsolationUnitStatusPatchToJSON(
          requestParameters['isolationUnitStatusPatch'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      IsolationUnitEntityFromJSON(jsonValue),
    );
  }

  /**
   * Observed state only (ADR-0010); reserved for automation. Conditions are upserted by type: each entry replaces the stored entry of its type and every other type is preserved; nothing is removed (ADR-0022). lastTransitionTime is set by the server when status changes. Tenancy ids are set once known and preserved when omitted.
   * Patch an isolation unit\'s status
   */
  async v1IsolationUnitsIdStatusPatch(
    requestParameters: V1IsolationUnitsIdStatusPatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<IsolationUnitEntity> {
    const response = await this.v1IsolationUnitsIdStatusPatchRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}

/**
 * @export
 */
export const V1EnvironmentsEnvironmentIsolationUnitsGetCloudProviderEnum = {
  Gcp: 'gcp',
  Aws: 'aws',
  Azure: 'azure',
} as const;
export type V1EnvironmentsEnvironmentIsolationUnitsGetCloudProviderEnum =
  (typeof V1EnvironmentsEnvironmentIsolationUnitsGetCloudProviderEnum)[keyof typeof V1EnvironmentsEnvironmentIsolationUnitsGetCloudProviderEnum];
